import React, { Component } from 'react'
import t from '../components/Language/language'
import * as languageSettings from '../components/Language/languageSettings'
import StoreDetailsComponent from '../components/Stores/StoreDetailsComponent'
import { connect } from 'react-redux'
import AuthenticationService from '../components/Security/AuthenticationService'
import { Config } from '../Config'
import { initStoreDetail } from '../actions/modalAction'
import { bindActionCreators } from 'redux'
import { CommonConstants } from '../Constants'
import 'url-search-params-polyfill'
import Online from '../images/connection_online.png'
import Offline from '../images/connection_offline.png'
import ZOOMIcon from '../images/icon_ZOOM.png'
import CIBIcon from '../images/icon_CIB.png'
import { Row, Col, Table } from 'reactstrap'
import './ViewDetails.css'
import { checkAccess, getPermission } from '../actions/permissions'
import CommonLoader from '../components/Alerts/CommonLoader'
import NavigationService from '../components/Common/NavigationServices'
class StoreContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      isRemoteConnectionPermission: false,
      showCommonLoader: true
    }
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.navigate = new NavigationService()
    this.handleClick = this.handleClick.bind(this)
    this.renderSystemImage = this.renderSystemImage.bind(this)
    this.checkSystemStatus = this.checkSystemStatus.bind(this)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.token = this.authService.getToken()
    props.getPermission()
  }
  handleClick (did) {
    const params = new URLSearchParams(this.props.history.location.search)
    const uuid = params.get('uuid') ? params.get('uuid') : null
    if (uuid) {
      window.location.href = '/settings/stores/viewDetail?duid=' + did + '&uuid=' + uuid
    } else {
      window.location.href = '/settings/stores/viewDetail?duid=' + did
    }
  }
  componentWillMount () {
    const params = new URLSearchParams(this.props.history.location.search)
    const contextToken = params.get('suid') ? params.get('suid') : null
    this.props.initStoreDetail(contextToken, false, () => {
      this.setState({ showCommonLoader: false })
    })
  }

  renderHTTP (url) {
    return url.replace('https', 'http')
  }

  checkSystemStatus (data, isRemoteConnectionPermission) {
    return (
      <td>
        <img src={Online} className={'cstat img_padding  ' + (parseInt(data.Device_IsActive, 10) === 1 ? '' : 'hidden')} alt='Device Online' />
        <img src={Offline} className={'cstat img_padding  ' + (parseInt(data.Device_IsActive, 10) === 0 ? '' : 'hidden')} alt='Device Offline' />
        <span className='cstat'>
          {this.renderStatus(data, isRemoteConnectionPermission)}
        </span>
      </td>
    )
  }

  renderStatus (device, isRemoteConnectionPermission) {
    let language = this.state.currentLanguage
    if (device.Device_IsActive === 1) {
      if (this.authService.isAdmin()) {
        return (<a style={{ 'textAlign': 'center', color: parseInt(device.Device_IsActive, 10) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{parseInt(device.Device_IsActive, 10) === 1 ? (t[language].settingsStoresOnline) : t[language].settingsStoresOffline}</a>)
      } else if (!this.authService.isAdmin()) {
        if (isRemoteConnectionPermission && device.Device_Name !== 'CIB') {
           return (<a style={{ color: parseInt(device.Device_IsActive, 10) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</a>)
        } else {
          return (<span style={{ color: 'black' }}> {device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</span>)
        }
      }
    } else {
      return (<span style={{ color: 'black' }}>{device.Device_IsActive ? t[language].settingsStoresOnline : device.Device_IsActive === 0 ? t[language].settingsStoresOffline : null }</span>)
    }
  }

  renderSystemImage (deviceName) {
    switch (deviceName) {
      case 'ZOOM': {
        return (<img src={ZOOMIcon} alt='Zoom' />)
      }
      case 'CIB': {
        return (<img src={CIBIcon} alt='CIB' />)
      }
      default: {
        return (deviceName)
      }
    }
  }

  renderRows (isRemoteConnectionPermission) {
    let row = this.props.stores.Device_Details
    let language = this.state.currentLanguage
    let rows = row.map((data, index) => {
      return (
        <tr className='tdata' key={index}>
          <td >{this.renderSystemImage(data.Device_Name)}</td>
          <td >{data.Device_MainVersion}</td>
          <td >{data.Device_SerialNumber}</td>
          {this.checkSystemStatus(data, isRemoteConnectionPermission)}
          <td onClick={() => this.handleClick(data.Device_UID)}><a className='viewDetials'>{t[language].View} <span>{t[language].Details}</span></a></td>
        </tr>
      )
    })
    return rows
  }

  render () {
    let language = this.state.currentLanguage
    let isRemoteConnectionPermission = checkAccess(CommonConstants.userPermissions.RemoteConnect)
    return (<section>
      <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
      <div className={'store-details ' + (this.state.showCommonLoader ? 'hidden' : '')}>
        <Row>
          <Col sm='12' lg='6' md='12' >
            <StoreDetailsComponent history={this.props.history} storedetails />
          </Col>
          <Col lg='6' sm='12' md='12'>
            <div className='device_details deviceDetails_table'>
              <h4 className='cib_header'> {t[language].settingsStoresRegisteredSystems} </h4>
              <Table className='sys_table_widget sys_table systemstatus_table'>
                <tbody>
                  <tr className='theader RegisterSystemTableHeader'>
                    <th>{t[language].StoreSettingsHeaderName} </th>
                    <th> {t[language].StoreSettingsHeaderVersion}</th>
                    <th> {t[language].StoreSettingsSerialno}</th>
                    <th> {t[language].StoreSettingsHeaderStatus}</th>
                    <th className='viewDetailsHeader' />
                  </tr>
                  {this.renderRows(isRemoteConnectionPermission)}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
    </section>
    )
  }
}

function mapStateToProps (state) {
  return {
    stores: state.StorePopupDetails.storePopupDetails,
    roles: state.roles
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      initStoreDetail: initStoreDetail,
      getPermission: getPermission
    }, dispatch
  )
}

export default connect(mapStateToProps, matchDispatchToProps)(StoreContainer)



// WEBPACK FOOTER //
// ./src/containers/StoreContainer.js